import React, { memo, useEffect, useRef } from 'react';

import Button from '../components/helpers/Button';

let currentVersion = null;

const CHECK_INTERVAL = 60 * 60 * 1000; // 1 hour

/**
 * App version checker.
 */
const AppVersionCheckComponent = () => {
  const alertRef = useRef(null);

  useEffect(() => {
    checkVersion();

    window.addEventListener('visibilitychange', checkVersionOnActivate);

    const intervalId = setInterval(checkVersion, CHECK_INTERVAL);

    return () => {
      window.removeEventListener('visibilitychange', checkVersionOnActivate);
      clearInterval(intervalId);
    };
  }, []);

  const checkVersionOnActivate = () => {
    if (document.visibilityState === 'visible') {
      checkVersion();
    }
  };

  const checkVersion = async () => {
    try {
      const controller = new AbortController();
      const id = setTimeout(() => controller.abort(), 5000);

      const response = await fetch(`/version.json?_=${Date.now()}`, {
        signal: controller.signal,
        cache: 'no-store',
      });

      clearTimeout(id);

      if (!response.ok) return;

      const { version } = await response.json();

      if (!currentVersion) {
        currentVersion = version;

        return;
      }

      if (currentVersion !== version) {
        window
          .jQuery(alertRef.current)
          .removeClass('hidden')
          .fadeIn();
      }
    } catch (error) {
      console.warn('Version check failed', error);
    }
  };

  const handleReload = () => {
    window.location.reload(true);
  };

  const handleClose = () => {
    if (alertRef.current) {
      window
        .jQuery(alertRef.current)
        .addClass('hidden')
        .fadeOut();
    }
  };

  return (
    <div ref={alertRef} className="alert alert-info fixed-bottom-alert hidden" role="alert">
      <button aria-label="Close" className="close" onClick={handleClose} type="button">
        <span aria-hidden="true">&times;</span>
      </button>
      <h4>A new version is available.</h4>
      <p>Reload the page to apply changes.</p>
      <p className="text-right">
        <Button onClick={handleReload}>Reload</Button>
      </p>
    </div>
  );
};

export const AppVersionCheck = memo(AppVersionCheckComponent);
